import { Button, Form } from "react-bootstrap";
import JSZip from "jszip";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { saveAs } from "file-saver";
import "./InclusionExclusionForm.css";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));
const InclusionExclusionForm = ({
  fieldOptions,
  typeOptions,
  uploadFileDetails,
  setUploadFileDetails,
  handleFileChange,
  formStatusNegativeAlert,
  setFormStatusNegativeAlert,
  handleInClusionExclusionSubMission,
  fileInputRef,
  selectedValues,
  setSelectedValues,
  options,
  setOptions,
}) => {
  const download = async () => {
    const zip = new JSZip();
    // Adding files to the zip
    zip.file(
      "SampleFiles/email.csv",
      "test1@email.com \n test2@email.com \n test3@email.com\n test4@email.com\n test5@email.com"
    );
    zip.file(
      "SampleFiles/phone.csv",
      "1422374242\n 1433374222\n 1476984567\n 1412484242\n 1413678242"
    );
    zip.file(
      "SampleFiles/website-url.csv",
      "google.com\n website.com\n network.com\n yahoo.com\n facebook.com"
    );
    // Creating a folder structure
    zip.folder("SampleFiles");
    // Generating the zip file and triggering download
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "sample_files.zip");
    });
  };
  const handleRemoveFile = () => {
    setUploadFileDetails((prev) => ({
      ...prev,
      csvData: [],
      fileName: "",
    }));
    fileInputRef.current.value = ""; // Reset the input field value
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
    const selectedKeys = Object.values(selectedValues).filter(
      (val) => val !== ""
    );
    const isFormValid =
      uploadFileDetails?.exclusionName !== "" &&
      uploadFileDetails?.fileName !== "" &&
      uploadFileDetails?.type !== "" &&
      uploadFileDetails?.csvData !== undefined &&
      selectedKeys.length >= 2;
    if (!isFormValid) {
      setFormStatusNegativeAlert(true);
    } else {
      handleInClusionExclusionSubMission();
    }
  };
  const fieldSelect = [
    { label: "Company Name", value: "company_name" },
    { label: "Address Line 1", value: "addressline1" },
    { label: "Address Line 2", value: "addressline2" },
    { label: "Address Line 3", value: "addressline3" },
    { label: "Address Line 4", value: "addressline4" },
    { label: "Address Line 5", value: "addressline5" },
    { label: "Post Code", value: "postcode" },
    { label: "Company Register Number", value: "crn" },
  ];
  useEffect(() => {
    if (uploadFileDetails.headers) {
      // Reset options and selectedValues when a new file is uploaded
      setOptions(
        uploadFileDetails.headers.map((header) => ({
          label: header,
          value: header,
        }))
      );
      setSelectedValues({});
    }
  }, [uploadFileDetails]); // Runs whenever uploadFileDetails changes
  const handleChange = (field, value) => {
    setSelectedValues((prev) => ({
      ...prev,
      [field]: value, // Update selected value for the specific field
    }));
  };
  return (
    <div>
      <h5 className="exclusion-form-header">Upload File</h5>
      <Form onSubmit={handleFormSubmit}>
        <Form.Group className="mt-3">
          <Form.Label className="label-exclusion">Name</Form.Label>
          <Form.Control
            type="text"
            required
            value={uploadFileDetails.exclusionName || ""}
            onChange={(e) => {
              setUploadFileDetails((prev) => ({
                ...prev,
                exclusionName: e.target.value,
              }));
            }}
          />
        </Form.Group>
        <div
          className="d-flex"
          style={{
            alignItems: "flex-end",
          }}
        >
          <Form.Group
            className="mt-2"
            style={{
              width: uploadFileDetails?.csvData.length > 0 ? "90%" : "423px",
            }}
          >
            <Form.Label className="label-exclusion">File</Form.Label>
            <Form.Control
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              ref={fileInputRef}
              required
            />
          </Form.Group>
          {uploadFileDetails?.csvData.length > 0 && (
            <div>
              <Button
                variant="outline-danger"
                size="sm"
                className="ms-2"
                onClick={handleRemoveFile}
              >
                <CloseIcon style={{ width: "18px", height: "27px" }} />
              </Button>
            </div>
          )}
        </div>
        <div className="mapping-container">
          <div
            style={{
              marginBottom: ".5rem",
            }}
          >
            Mapping
          </div>
          <div className="mapping-box">
            {fieldSelect.map((field, index) => (
              <div className="mapping-row" key={uuidv4()}>
                <Form.Label className="mapping-label">{field.label}</Form.Label>
                <Form.Select
                  className="mapping-select"
                  required={
                    !Object.values(selectedValues).some((value) => value !== "")
                  }
                  value={selectedValues[field.value] || ""}
                  onChange={(e) => handleChange(field.value, e.target.value)}
                >
                  <option value="">Select an option</option>
                  {options.map((opt, idx) => (
                    <option
                      key={uuidv4()}
                      value={opt.value}
                      disabled={
                        Object.values(selectedValues).includes(opt.value) &&
                        selectedValues[field.value] !== opt.value
                      }
                    >
                      {opt.label}
                    </option>
                  ))}
                </Form.Select>
              </div>
            ))}
          </div>
        </div>
        <div className="d-flex justify-content-center gap-1 my-3 align-items-center">
          <span>Click here for </span>
          <a onClick={download} download className="sample-file-click">
            {" "}
            Sample Files
          </a>
        </div>{" "}
        <div className="d-flex justify-content-center align-items-center gap-2">
          <Button
            type="submit"
            style={{ color: "white", border: "none" }}
            className="custom-login-button"
          >
            Upload
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default InclusionExclusionForm;
